import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=6bf54cda&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"
import style0 from "./SearchPage.scss?vue&type=style&index=0&id=6bf54cda&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf54cda",
  null
  
)

export default component.exports